import { render, staticRenderFns } from "./crearCategoriaModal.vue?vue&type=template&id=ef5254d6"
import script from "./crearCategoriaModal.vue?vue&type=script&lang=js"
export * from "./crearCategoriaModal.vue?vue&type=script&lang=js"
import style0 from "./crearCategoriaModal.vue?vue&type=style&index=0&id=ef5254d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports